var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.48,
    height: 17.845,
    viewBox: "0 0 19.48 17.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.909,17.845H1.949A1.917,1.917,0,0,1,0,15.967V7.514A1.917,1.917,0,0,1,1.949,5.636H4.414L8.991.338A.992.992,0,0,1,9.741,0h1.57a1.981,1.981,0,0,1,1.582.78,1.829,1.829,0,0,1,.267,1.693L12.066,5.636h5.467a1.916,1.916,0,0,1,1.948,1.878V9.392a.914.914,0,0,1-.061.329l-2.686,6.9A1.957,1.957,0,0,1,14.909,17.845ZM10.2,1.878,5.845,6.915v9.052h9.065l2.623-6.745V7.514H10.715a.988.988,0,0,1-.79-.391.912.912,0,0,1-.133-.847l1.521-4.4ZM1.949,7.514v8.453H3.9V7.514Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLike);
export default __webpack_public_path__ + "static/media/ico-like.b5dec23adb984645aa70cca71f28a4d5.svg";
export { ForwardRef as ReactComponent };